<div class="my-3 my-md-5">
    <div class="container-fluid px-4">
            <mat-accordion class="example-headers-align" multi>
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <i class="fas fa-sliders-h"></i> <span class="pl-2">Filters</span>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                    <div class="row mb-2 mt-2">
                        <div class="col-sm-3 mt-2"><input class="form-control" [(ngModel)]="search" type="text" placeholder="Search" /></div>
                        <div class="col-sm-2 mt-2" *ngIf="lead_sources.length > 0">
                            <!-- <mat-select  placeholder="Lead Source" (selectionChange)="loadleads(0,perpage)" [(ngModel)]="lead_source" multiple> -->
                              <mat-select  placeholder="Lead Source" [(ngModel)]="lead_source" multiple>
                                <mat-option value="{{lsources.id}}" *ngFor="let lsources of lead_sources">{{lsources.source_name}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2">
                            <!-- <mat-select  placeholder="Lead Status" (selectionChange)="loadleads(0,perpage)" [(ngModel)]="lead_status" (click)="setSearchValue('lead_status')" multiple> -->
                              <mat-select  placeholder="Lead Status" [(ngModel)]="lead_status" (click)="setSearchValue('lead_status')" multiple>
                              <input class="mySearchInput"
                                #lead_status_Search focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'lead_status')"
                                (keydown)="$event.stopPropagation()" autocomplete="off"
                                placeholder="Search"
                                id="lead_status_Search">
                                
                                <mat-option [value]="lstatus.id" *ngFor="let lstatus of leadallStatus">{{lstatus.name}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2">
                          <!-- <mat-select  placeholder="Share Link" (selectionChange)="loadleads(0,perpage)" [(ngModel)]="link_share_filter"> -->
                            <mat-select  placeholder="Share Link" [(ngModel)]="link_share_filter">
                              <mat-option value="0">All</mat-option>
                              <mat-option value="1">Yes</mat-option>
                              <mat-option value="2">No</mat-option>
                          </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2">
                          <!-- <mat-select  placeholder="Bds" (selectionChange)="loadleads(0,perpage)" [(ngModel)]="bd" > -->
                            <mat-select  placeholder="Bds" [(ngModel)]="bd" >
                              <mat-option>All</mat-option>
                              <mat-option value="{{bd.id}}" *ngFor="let bd of allbds">{{bd.name}}</mat-option>
                          </mat-select>
                      </div>
                       

                    </div>
                    <div class="row">
                        <div class="col-sm-3 mt-2">
                            <mat-form-field appearance="fill">
                                <mat-label>Enter a date range</mat-label>
                                <mat-date-range-input [rangePicker]="picker">
                                    <input matStartDate #dateRangeStart placeholder="Start date">
                                    <input matEndDate #dateRangeEnd placeholder="End date" (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)">
                                </mat-date-range-input>
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-date-range-picker #picker></mat-date-range-picker>
                            </mat-form-field>
                            <mat-icon (click)="clearDate()">clear</mat-icon>

                        </div>

                        <div class="col-sm-3 mt-4">
                          <button type="button" class="btn btn-primary ml-2 mb-4" (click)="loadleads(0,perpage)"> <i class="fa fa-search" aria-hidden="true"></i> Search Data</button>
                          <button type="button" class="btn btn-primary ml-2 mb-4" (click)="resetFilters()"> <i class="fa fa-sync"></i> Reset Filters</button>
                        </div>
                        
                    </div>

                </mat-expansion-panel>
            </mat-accordion>

        <div class="card">
            <div class="container-fluid row">
                <div class="col-sm-8 p-3">
                    <!-- <button class="btn btn-success mb-4" (click)="saveDetails()" [disabled]="submitted"><i class="fas fa-spin fa-spinner" *ngIf="submitted"></i> Save</button> -->
                    <button type="button" class="btn btn-success ml-2 mb-4" [disabled]="loading" (click)="loadleads(0,perpage)"><i class="fa fa-sync" [ngClass]="{'fa-spin':loading}"></i> Refresh Sheet</button>
                    <button type="button" *ngIf="myrole=='1' || (myrole=='14' && isCMAccess=='1')" class="btn btn-success ml-2  mb-4" [disabled]="loading" (click)="exportLeadPartnerData()"><i class="fa fa-file-excel"></i> Export List For Partner</button>
                </div>
                <div class="col-sm-4">
                    <mat-paginator #paginatorTop [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage" (page)="pageEvent = getServerData($event);paginatorBottom.pageIndex = $event.pageIndex"></mat-paginator>
                </div>
            </div>
            <div class="text-center" *ngIf="loading"><i class="fa fa-spin fa-spinner fa-2x"></i></div>
            <hot-table [hotId]="id" [colHeaders]="true" [hiddenColumns]="hideColumn" [columnSorting]="false" width="100%" [height]="600" [rowHeaders]="true" [data]="leads" [beforeChange]="onBeforeChange" [afterOnCellMouseDown]="afterOnCellMouseDownCallBack"  licenseKey="non-commercial-and-evaluation" [autoWrapRow]="false" [autoWrapCol]="false">
                <hot-column class="bg-red" style="background: red" data="id" [readOnly]="true" title="ID"></hot-column>
                <hot-column data="patient_id" renderer="html" [readOnly]="true" title="Patient Id"></hot-column>
                <hot-column data="glamyo_patient_id" renderer="html" [readOnly]="true" title="Glamyo Patient Id"></hot-column>
               
                <hot-column data="lead_time" [readOnly]="true" title="Lead Created Time"></hot-column>
                <hot-column [copyable]="false" data="mobile" renderer="html" [readOnly]="true" title="Lead Mobile"></hot-column>


                <hot-column data="lead_name" [readOnly]="true" title="Lead Name"></hot-column>
                

                <hot-column data="city_name" [readOnly]="true" title="City Name"></hot-column>
                <hot-column data="circle_name" [readOnly]="true" type="text" [source]="sheetCircle" title="To Circle"></hot-column>
                <!-- <hot-column data="" type="dropdown" [source]="sheetCircle2" title="To Circle2"></hot-column> -->
                <hot-column data="bd_name" [readOnly]="true" title="Lead Owner Name"></hot-column>

                
                
                
                <hot-column data="description" [readOnly]="true" title="Description" width="300"></hot-column>

                <!-- Insurance BD Details -->
                <hot-column data="insurance_bd_email" [readOnly]="false" type="dropdown" [source]="bds" title="Insurance Lead Owner"></hot-column>
                <hot-column data="insurance_bd_description" [readOnly]="false" title="Insurance Description" width="300"></hot-column>
                <!-- Insurance BD Details -->

                
                <hot-column data="treatment_name" [readOnly]="true" type="text" [source]="treatments" title="Treatment"></hot-column>
                <hot-column data="payment_mode" [readOnly]="true" type="text" allowEmpty="true" [source]="paymentOpt" title="Mode of Payment"></hot-column>
                
                <hot-column width="250" [readOnly]="true" data="lead_status_name" type="text" [source]="leadStatus" title="Status"></hot-column>

                <hot-column renderer="html" data="lead_history" [readOnly]="true" title="History"></hot-column>
                
                <hot-column renderer="html" data="is_appLink_sent" [readOnly]="true" title="Share App Link Status"></hot-column>
                <hot-column renderer="html" data="send_applink" [readOnly]="true" title="Share App Link"></hot-column>
            </hot-table>
            <mat-paginator #paginatorBottom [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage" (page)="pageEvent = getServerData($event);paginatorTop.pageIndex = $event.pageIndex"></mat-paginator>
        </div>
    </div>
</div>

<!-- Duplicate Modal -->
<div class="modal fade" id="duplicateModal">
    <div class="modal-dialog">
      <div class="modal-content">

        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title">Create Duplicate Lead</h4>
          <button type="button" class="close" (click)="hideduplicateModal()"></button>
        </div>

        <!-- Modal body -->
          <div class="modal-body">
              <div class="form-group">
                  <div class="row">
                    <div class="col-sm-12"><h2>Do you want to create duplicate lead?</h2></div>

                    <div *ngIf="copyData" class="col-sm-12 text-center" style="font-size: 22px;"><span><i class="fa fa-spin fa-spinner"></i> Uploading...</span></div>

                  </div>

              </div>
          </div>

        <!-- Modal footer -->
        <div class="modal-footer">
           <button type="button" class="btn btn-success" (click)="copyLead()">Confirm</button>
          <button type="button" class="btn" (click)="hideduplicateModal()">Close</button>
        </div>
      </div>
    </div>
  </div>

<!--For Show Payment Mode and Treatment not Selected Modal -->
<div class="modal fade" id="paymentTreatmentModal">
    <div class="modal-dialog">
      <div class="modal-content">

        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title" style="font-weight: bold;">Action Required</h4>
          <button type="button" class="close" (click)="hideStatusModal('1')"></button>
        </div>

        <!-- Modal body -->
          <div class="modal-body">
                <div class="form-group">
                  <div class="row">
                    <div style="font-size: 18px;" class="col-sm-12 modal-title" id="StatusText"><h2></h2></div>
                  </div>
                </div>
          </div>

        <!-- Modal footer -->
        <div class="modal-footer">
          <button type="button" class="btn" (click)="hideStatusModal('1')">Close</button>
        </div>
      </div>
    </div>
  </div>

  <!--For Show Payment Mode and Treatment not Selected Modal -->
<div class="modal fade" id="previousdnpfollowModal">
    <div class="modal-dialog">
      <div class="modal-content">

        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title" style="font-weight: bold;">Action Required</h4>
          <button type="button" class="close" (click)="hideStatusModal('2')"></button>
        </div>

        <!-- Modal body -->
          <div class="modal-body">
                <div class="form-group">
                  <div class="row">
                    <div style="font-size: 18px;" class="col-sm-12 modal-title" id="ActionTextMessage"><h2></h2></div>
                  </div>
                </div>
          </div>

        <!-- Modal footer -->
        <div class="modal-footer">
          <button type="button" class="btn" (click)="hideStatusModal('2')">Close</button>
        </div>
      </div>
    </div>
  </div>

   <!--For Show Different Payment Mode Error Modal -->
<div class="modal fade" id="paymentModeErrorModal">
  <div class="modal-dialog">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title" style="font-weight: bold;">Action Required</h4>
        <button type="button" class="close" (click)="hideStatusModal('3')"></button>
      </div>

      <!-- Modal body -->
        <div class="modal-body">
              <div class="form-group">
                <div class="row">
                  <div style="font-size: 18px;" class="col-sm-12 modal-title" id="PaymentModeErrorMessage"><h2></h2></div>
                </div>
              </div>
        </div>

      <!-- Modal footer -->
      <div class="modal-footer">
        <button type="button" class="btn" (click)="hideStatusModal('3')">Close</button>
      </div>
    </div>
  </div>
</div>


<!------------For Show lead History------------------->
<!-- The Modal to view history -->
<div class="modal fade" id="myHistoryModal">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
          <h4 class="modal-title">Update History</h4>
          <button type="button" class="close" (click)="closeHistoryPopup()"></button>
      </div>
      <div class="modal-body">
          <table class="table table-hover table-outline table-vcenter text-nowrap card-table">
            <tbody>
                <tr *ngFor="let updatedLog of updatedLodData">
                    <td>
                        <div [innerHTML]="updatedLog.message | safe:'html'"></div>
                        <div class="small text-muted">
                            <i class="fas fa-clock"></i> {{updatedLog.created_at*1000|date:'dMMM, yyyy H:mm aa'}}
                        </div>
                    </td>
                </tr>
                <tr *ngIf="!updatedLodData.length && history_loaded">
                    <td>No history found</td>
                </tr>
                <tr *ngIf="history_loading">
                    <td><i class="fa fa-spin fa-spinner"></i></td>
                </tr>
            </tbody>
        </table>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn" (click)="closeHistoryPopup()">Close</button>
      </div>
    </div>
  </div>
</div>


<!-----------------For Click to Call-------------------------->
  <div class="modal fade" id="click_to_call_progress" data-keyboard="false" data-backdrop="static">
    <div class="modal-dialog">
      <div class="modal-content">
  
        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title" style="font-weight: bold;">Call Progression</h4>
        </div>
  
        <!-- Modal body -->
          <div class="modal-body">
                <div class="alert alert-danger" *ngIf="progression_msg">
                  <strong>Warning!</strong> {{progression_msg}}
                </div>
                <div class="form-group">
                  <div class="row">
                    <div style="font-size: 18px;" class="col-sm-12 modal-title text-center" id="click_to_call_progress_html">
                      <i class="fa fa-cog fa-spin"></i><br />
                      <h2>Call is under progress.</h2>
                    
                    </div>
                  </div>
                </div>
          </div>
  
        <!-- Modal footer -->
        <div class="modal-footer">
          <button type="button" [disabled]="end_to_call_btn_disable" class="btn btn-success" (click)="endClicktoCall()">Close</button>
        </div>
      </div>
    </div>
  </div>
